import styled from 'styled-components';

import { Styling } from '../../constants';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-grow: 1;
`;

export const Header = styled.div`
  width: 100%;
  flex-grow: 0;
  background-color: #f9f8f8;
  padding: ${Styling.DEFAULT_SPACING}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  background-color: white;
`;
